import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  notification,
} from "antd";
import ReactQuill from "react-quill";
import moment from "moment";
import { useLocation, useNavigate, Link } from "react-router-dom";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { addeditdata } from "../../../controllers/V1/cms/campaignController";
import { list as userList } from "../../../controllers/V1/users/usersController";
import "react-quill/dist/quill.snow.css";
import "react-datepicker/dist/react-datepicker.css";
import { ASSETS_BASE_URL } from "../../../config/constants";
import UploadImage from "../products/UploadImge";
import { Image } from "antd";

import ImgUploader from "../../../components/ImageUploader/ImgUploader"

const { Option } = Select;

const CampaignAddEdit = () => {
  const location = useLocation();
  const state = location.state; // State for edit mode
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({});
  const [showNumberRangePrefix, setShowNumberRangePrefix] = useState(true);
  // Set initial form values for edit mode
  const [ADDEDITDATA, setAddEditData] = useState(state || []);
  const [isOpenUpload, setIsOpenUpload] = useState(false);
  const [childData, setChildData] = useState("");

  const [gameLogo, setGameLogo] = useState(ADDEDITDATA?.gameLogo || "");
  const [logoPopup, setLogoPopup] = useState(false);
  const toggleLogoPopup = () => setLogoPopup(!logoPopup);
  const [usersList, setUsersList] = useState([]);

  const handleUploadImage = () => setIsOpenUpload(!isOpenUpload);
  const handleChildData = (data) => {
    setChildData(data);
    if (data?._id) {
      setAddEditData((prevState) => ({
        ...prevState,
        image: data?.url || "",
      }));
      form.setFieldsValue({ image: data?.url || "" }); // Update the form's image field
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (Array.isArray(values.assigned_user) && values.assigned_user.length > 5) {
        notification.error({
          message: "Limit Exceeded",
          description: "You can assign a maximum of 5 users only.",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 3,
        });
        return;
      }
      const formattedValues = {
        ...values,
        editId: state?._id || undefined, // Pass ID in edit mode
        image: childData?.url || state?.image || "N/A", // Handle image
        gameLogo : gameLogo || "",
        assigned_user: values.assigned_user || [],
      };
      const res = await addeditdata(formattedValues);
      if (res.status === true) {
        notification.success({
          message: "Success",
          description: "Data successfully added/updated.",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
        navigate("/campaign/list");
      } else {
        notification.error({
          message: "Error",
          description: res.message,
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      console.error("Error during submission:", error);
    }
  };

   /*********************************************************
     *  This function is use to fetch vendor list
     *********************************************************/
    const getList = async () => {
      try {
        setUsersList([]);
        const options = {
          type: "",
          condition: {},
          select: {},
          sort: { 
            // _id: -1
            users_name: 1
           },
          skip: 0,
          limit: 0,
        };
        const listData = await userList(options);
        if (listData.status === true) {
          if (listData.result.length > 0) {
            // console.log('user count', listData?.result.length)
            setUsersList(listData?.result);
          } else {
            setUsersList([]);
          }
        } else {
          setUsersList([]);
        }
      } catch (error) {
        console.log('user list error', error);
      }
    }; //End

  useEffect(() => {
    const initial = state
      ? {
          ...state,
          draw_date: state.draw_date
            ? moment(state.draw_date).format("YYYY-MM-DD")
            : "", // Convert to YYYY-MM-DD format
          number_range_prefix: state?.enable_number_range_prefix
            ? state?.number_range_prefix
            : "",
        }
      : {};
    setInitialValues(initial);
    form.setFieldsValue(initial); // Populate form fields
  }, [state, form]);

  const handleValuesChange = (changedValues) => {
    if ("enable_number_range_prefix" in changedValues) {
      setShowNumberRangePrefix(
        changedValues.enable_number_range_prefix === "Y"
      );
    }
  };

  useEffect(() => {
    if (state?.enable_number_range_prefix === "N") {
      setShowNumberRangePrefix(false);
    }
    document.title = `Orbit Kuwait || Campaign's ${
      state?._id ? "Edit" : "Add"
    }`;
  }, [state]);

  useEffect(() => {
    getList();
  }, [])

  return (
    <div className="container-fluid">
      <div className="Inventory_edit_page_main_div">
        <h5 className="inventory_edit_page_heading">
          {state?._id ? "Edit" : "Add"} Campaign
        </h5>
        <Link to="/campaign/list">
          <Button type="secondary">
            <ArrowLeftOutlined /> Back
          </Button>
        </Link>
      </div>

      <div className="card shadow mb-4 dataBase_table_Add_Data">
        <div style={{ padding: "20px" }}>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={initialValues}
            onValuesChange={handleValuesChange}
          >
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label="Category"
                  name="category"
                  rules={[
                    { required: true, message: "Please write a category!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Sub Category"
                  name="sub_category"
                  rules={[
                    { required: true, message: "Please write a sub-category!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Title"
                  name="title"
                  rules={[
                    { required: true, message: "Please enter the title!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label="Description"
                  name="description"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the description!",
                    },
                  ]}
                >
                  <ReactQuill />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label="Straight Amount"
                  name="straight_add_on_amount"
                >
                  <Input type="number" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Rumble Amount" name="rumble_add_on_amount">
                  <Input type="number" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Chance Amount" name="chance_add_on_amount">
                  <Input type="number" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Countdown Status" name="countdown_status">
                  <Select>
                    <Option value="Y">Yes</Option>
                    <Option value="N">No</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Lotto Type"
                  name="lotto_type"
                  rules={[
                    { required: true, message: "Please select lotto type!" },
                  ]}
                >
                  <Select defaultValue="">
                    <Option value="" disabled>
                      Select lotto type
                    </Option>
                    <Option value="1">1</Option>
                    <Option value="2">2</Option>
                    <Option value="3">3</Option>
                    <Option value="4">4</Option>
                    <Option value="5">5</Option>
                    <Option value="6">6</Option>
                    <Option value="7">7</Option>
                  </Select>

                  {/* <Input /> */}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Draw Date"
                  name="draw_date"
                  rules={[
                    { required: true, message: "Please select a draw date!" },
                  ]}
                >
                  <input
                    type="date"
                    className="form-control store_input_field"
                    id="draw_date"
                    value={
                      initialValues?.draw_date
                        ? moment(initialValues.draw_date).format("YYYY-MM-DD")
                        : ""
                    }
                    onChange={(e) =>
                      form.setFieldsValue({ draw_date: e.target.value })
                    }
                    disabled={!!state?._id}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label="Draw Time"
                  name="draw_time"
                  rules={[
                    { required: true, message: "Please select a draw time!" },
                  ]}
                >
                  <input
                    type="time"
                    className="form-control store_input_field"
                    id="draw_time"
                    value={
                      initialValues?.draw_time?.split("T")[0]?.draw_time || ""
                    } // Bind form state
                    onChange={
                      (e) => form.setFieldsValue({ draw_time: e.target.value }) // Update form state
                    }
                    disabled={!!state?._id}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label="Enable Number Range Prefix"
                  name="enable_number_range_prefix"
                >
                  <Select>
                    <Option value="Y">Yes</Option>
                    <Option value="N">No</Option>
                  </Select>
                </Form.Item>
              </Col>

              {showNumberRangePrefix ? (
                <Col span={8}>
                  <Form.Item
                    label="Number Range Prefix"
                    name="number_range_prefix"
                  >
                    <Input type="number" />
                  </Form.Item>
                </Col>
              ) : (
                ""
              )}
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Lotto Range Start" name="lotto_range_start">
                  <Input type="number" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Lotto Range End" name="lotto_range_end">
                  <Input type="number" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Ticket Number Repeat"
                  name="ticket_number_repeat"
                >
                  <Select>
                    <Option value="Y">Yes</Option>
                    <Option value="N">No</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label="Show On"
                  name="show_on"
                  rules={[
                    {
                      required: true,
                      message: "Please select display options!",
                    },
                  ]}
                >
                  <Select mode="multiple">
                    <Option value="POS">POS</Option>
                    <Option value="Web" disabled>
                      Web
                    </Option>
                    <Option value="App" disabled>
                      App
                    </Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Seq. Order" name="seq_order">
                  <Input type="number" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Assigned User"
                  name="assigned_user"
                  rules={[
                    {
                      required: false,
                      message: "!",
                    },
                  ]}
                >
                  <Select mode="multiple" placeholder="Select User">
                    {Array.isArray(usersList) &&
                      usersList.map((user, index) => (
                        <Option key={index} value={user?._id}>
                          {user?.users_name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={4}>
                <Form.Item
                  label="Upload Image"
                  name="image"
                  rules={[{ required: true, message: "Please select Image!" }]}
                >
                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <div className="image_select_btn">
                      <button
                        type="button"
                        className="btn btn-light categories_cancel_button"
                        onClick={() => {
                          handleUploadImage();
                        }}
                      >
                        Select
                      </button>
                      <span>{childData?.url}</span>
                    </div>
                    {state?._id ? (
                      <Image
                        width={100}
                        src={ASSETS_BASE_URL + initialValues?.image}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item
                  label="Game Logo"
                  name="image"
                  rules={[{ required: true, message: "Please select logo!" }]}
                >
                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <div className="image_select_btn">
                      <button
                        type="button"
                        className="btn btn-light categories_cancel_button"
                        onClick={() => {
                          toggleLogoPopup();
                        }}
                      >
                        Select
                      </button>
                      <span>{childData?.url}</span>
                    </div>
                    {state?._id ? (
                      <Image
                        width={100}
                        src={ASSETS_BASE_URL + gameLogo}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </Form.Item>
              </Col>
            </Row>

            {/* <Button type="primary" htmlType="submit" className="btn btn-primary inventory_save_button text center">
              Save
            </Button> */}
            <div className="verndor_dashboard_add_edit_button text-center">
              <button
                type="submit"
                class="btn btn-primary inventory_save_button"
              >
                Save
              </button>
            </div>
          </Form>
        </div>
      </div>
      <UploadImage
        openUpload={isOpenUpload}
        toggleUploadOpen={handleUploadImage}
        onSendData={handleChildData}
      />

      <ImgUploader
        openUpload={logoPopup}
        toggleUploadOpen={toggleLogoPopup}
        setImgUrl={setGameLogo}
      />
    </div>
  );
};

export default CampaignAddEdit;
